<template>
  <InterventionTemplateForm :productTypes="productTypes" @submit="saveTemplate" />
</template>

<script setup lang="ts">
import InterventionTemplateForm from "@/components/InterventionTemplateForm.vue";
import { ProductType } from "@/types";
import { postInterventionTemplate } from "@/utils/intervention-template-api";

async function saveTemplate(payload) {
  await postInterventionTemplate(payload);
}
const productTypes = Object.values(ProductType);
</script>
